export default {
  'ticket.operator': 'Operator',
  'ticket.status': 'Status',
  'ticket.lastupdate': 'Last Update',
  'ticket.ticketid': 'Request ID',
  'ticket.subject': 'Subject',
  'ticket.total': 'Total Requests',
  'ticket.notassigned': 'Not Assigned',
  'ticket.addnewticket': 'New Request',
  'ticket.search': 'Search',
  'ticket.knowleadgebase': 'Knowleadgebase',
  'ticket.announcements': 'Announcements',
  'ticket.description': 'Description',
  'ticket.mytickets': 'Requests',
  'ticket.knowledgebase': 'Knowledgebase',
  'ticket.all': 'All',
  'ticket.done': 'Done',
  'ticket.inprogress': 'Inprogress',
  'ticket.new': 'New',
  'ticket.ticketsInbox': 'Inbox',
  'ticket.ticketsUnread': 'Unread',
  'ticket.close': 'Close',
  'ticket.ticketid': 'Request ID',
  'ticket.subject': 'Subject',
  'ticket.ticketType': 'Request Type',
  'ticket.sender': 'Sender',
  'ticket.findtickets': 'Search Request',
  'ticket.newticket': 'New Request',
  'ticket.send': 'Send',
  'ticket.close': 'close',
  'ticket.uploadYourImage': 'upload image',
  'ticket.indertSuccessFully': 'Your request has been successfully submitted',
  'ticket.notassigned': 'Tripsi support',
  'ticket.text': 'Text',
  'ticket.insertSubject': 'Please enter the subject of your request',
  'ticket.insertText': 'Please enter the text of your request',
  'ticket.insertMessageAndSubject':
    'Please enter the text and subject of your request',
  'ticket.items': 'Items',
  'ticket.item': 'Item',
  'ticket.submitinwriting': 'Submit in writing',
  'ticket.dateoforder': 'Date of order',
  'ticket.dateoftravel': 'Date of travel',
  'ticket.flight': 'Flight',
  'ticket.details': 'Details',
  'ticket.responseaverage': 'Response average',
  'ticket.supportnum': 'Support number',
  'ticket.support': 'Tripsi Support',
  'ticket.minutes': 'Minutes',
  'ticket.reply': 'Response',
  'ticket.supervisor': 'Supervisor',
  'ticket.attachment': 'Attachment',
  'ticket.preview': 'Preview',

  'ticket.title': 'Title',
  'ticket.createddate': 'Created date',
  'ticket.ticketNumber': 'Ticket number',
  'ticket.message': 'Message',
  'ticket.lastanswerdate': 'Last answered',
  'ticket.attachphoto':
    'In this part of the request section, you can upload your desired photo through the link below .',
};
